import { MetaFunction } from "@remix-run/node";
import { tournamentPageLoader } from "./loader";
import { generateMetaTags } from "~/shared/helpers/metaTags/generateMetaTags";

export const tournamentPageMeta: MetaFunction<typeof tournamentPageLoader> = ({ data }) => {
  if (!data) return generateMetaTags({});

  const tournament = data.tournament;
  const gameId = data.gameId;
  const isEventOnline = tournament.location?.toLowerCase()?.includes("online");

  let metaTitle: string | undefined = undefined;
  let metaDescription: string | undefined = undefined;
  switch (gameId) {
    case "cs": {
      metaTitle = `${tournament.name} - ${tournament.circuit?.name ?? ""} CS2 Tournament`;
      metaDescription = `A professional Counter-Strike tournament where ${tournament.numberOfTeams} teams compete for ${tournament.prizePool} played ${isEventOnline ? "online" : `in ${tournament.location}`}. Find out all the latest info on Brackets, Schedules, Teams, Lineups and more!`;
      break;
    }
    case "dota": {
      metaTitle = `${tournament.name} Dota 2 Tournament`;
      metaDescription = `A professional Dota 2 tournament where ${tournament.numberOfTeams} teams compete for ${tournament.prizePool} played ${isEventOnline ? "online" : `in ${tournament.location}`}. Find out all the latest info on Brackets, Schedules, Teams, Lineups and more!`;
      break;
    }
    case "rl": {
      metaTitle = `${tournament.name} - ${tournament.circuit?.name ?? ""} Rocket League Tournament`;
      metaDescription = `A professional Rocket League tournament where ${tournament.numberOfTeams} teams compete for ${tournament.prizePool} played ${isEventOnline ? "online" : `in ${tournament.location}`}. Find out all the latest info on Brackets, Schedules, Teams, Lineups and more!`;
      break;
    }
    default:
      gameId satisfies never;
      break;
  }

  return generateMetaTags({
    metaDescription,
    metaTitle,
    metaImageUrl: `/${gameId}/tournaments/${tournament.id}/ogimage`,
  });
};
